import { combineReducers } from 'redux';
import list from './list';
import paging from './paging';
import sorting from './sorting';
import count from './count';
import categories from './categories';
import activeCategory from './activeCategory';
import detail from './detail';

export default combineReducers({
  list,
  paging,
  sorting,
  count,
  categories,
  activeCategory,
  detail,
});
